module.exports = __webpack_public_path__ + "img/sch4-title.8d5045cb.png";